export const compressImage = (file, options = {}) =>
  new Promise((resolve, reject) => {
    const config = {
      maxWidth: 800,
      maxHeight: 600,
      quality: 0.8,
      maxSizeKB: 500,
      minSizeKB: 100, // Solo comprimir si es mayor o igual a 100KB
      ...options,
    }

    if (!file.type.startsWith("image/")) {
      reject(new Error("El archivo debe ser una imagen"))
      return
    }

    const fileSizeKB = file.size / 1024

    if (fileSizeKB < 100) {
      const img = new Image()
      img.onload = () => {
        resolve({
          file,
          originalSize: file.size,
          compressedSize: file.size,
          compressionRatio: 0,
          dimensions: { width: img.width, height: img.height },
          wasCompressed: false,
        })
      }
      img.onerror = () => {
        resolve({
          file,
          originalSize: file.size,
          compressedSize: file.size,
          compressionRatio: 0,
          dimensions: null,
          wasCompressed: false,
        })
      }
      const reader = new FileReader()
      reader.onload = e => {
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
      return
    }

    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    const img = new Image()

    img.onload = () => {
      let { width, height } = img

      if (width > config.maxWidth || height > config.maxHeight) {
        const ratio = Math.min(
          config.maxWidth / width,
          config.maxHeight / height
        )
        width = Math.floor(width * ratio)
        height = Math.floor(height * ratio)
      }

      canvas.width = width
      canvas.height = height

      ctx.fillStyle = "white"
      ctx.fillRect(0, 0, width, height)
      ctx.drawImage(img, 0, 0, width, height)

      // Función para ajustar la calidad si es necesario
      const tryCompress = quality => {
        canvas.toBlob(
          blob => {
            if (!blob) {
              reject(new Error("Error al comprimir la imagen"))
              return
            }

            const sizeKB = blob.size / 1024

            if (sizeKB <= config.maxSizeKB || quality <= 0.1) {
              const compressedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              })

              resolve({
                file: compressedFile,
                originalSize: file.size,
                compressedSize: blob.size,
                compressionRatio: Math.round((1 - blob.size / file.size) * 100),
                dimensions: { width, height },
                wasCompressed: true,
              })
            } else {
              tryCompress(quality - 0.1)
            }
          },
          "image/jpeg",
          quality
        )
      }

      tryCompress(config.quality)
    }

    img.onerror = () => {
      reject(new Error("Error al cargar la imagen"))
    }

    const reader = new FileReader()
    reader.onload = e => {
      img.src = e.target.result
    }
    reader.onerror = () => {
      reject(new Error("Error al leer el archivo"))
    }
    reader.readAsDataURL(file)
  })

export const withCacheBust = (url, version) => {
  if (!url || !version) return url
  if (!/^https?:\/\//i.test(url)) return url
  const sep = url.includes("?") ? "&" : "?"
  return `${url}${sep}v=${encodeURIComponent(version)}`
}
